import styled from "styled-components";
import { IconButton } from "@similarweb/ui-components";
import { colorsPalettes, rgba } from "@similarweb/styles";
import { setFontVariant } from "@similarweb/styles";
import { BaseFlex, CenteredFlexRow, FlexColumn, FlexRow } from "pro-features/styled components/StyledFlex/src/StyledFlex";
import { NavBarIcon } from "@similarweb/ui-components";
export const EducationContainer = styled(BaseFlex)`
    min-height: 56px;
    box-sizing: border-box;
    justify-content: space-between;
    align-items: center;
    padding: 0 23px;
    background-color: ${colorsPalettes.blue[100]};
`;

export const EducationContainerBig = styled(EducationContainer)`
    align-items: flex-start;
    max-height: 165px;
    padding: 20px 29px 20px 32px;
    border-radius: 6px;
    margin: 0 auto 32px;

    @media (max-width: 1919px) {
        max-height: 136px;
        padding: 16px 21px 16px 24px;
    }

    @media (max-width: 1399px) {
        max-height: 1200px;
        padding: 12px 21px 12px 24px;
    }
`;

export const ButtonStyle = styled(IconButton)`
    color: ${setFontVariant("button", colorsPalettes.blue[400])};
`;

export const ButtonWrapper = styled.div`
    border-radius: 6px;
    position: relative;
    flex: none;
    width: 220px;
    height: 125px;
    margin-right: 20px;
    box-shadow: 0 3px 6px rgba(14, 30, 62, 0.08);

    &:hover {
        padding: 0;
    }

    @media (max-width: 1919px) {
        margin-right: 16px;
        width: 182px;
        height: 104px;
    }

    @media (max-width: 1399px) {
        margin-right: 12px;
        width: 165px;
        height: 96px;
    }
`;
export const VideoTimeText = styled(CenteredFlexRow)`
    position: absolute;
    bottom: 8px;
    right: 8px;
    gap: 8px;
    width: 52px;
    height: 24px;
    background: ${rgba(colorsPalettes.carbon[500], 0.7)};
    border-radius: 6px;
    ${setFontVariant("subtitle2", colorsPalettes.carbon[0])};
    line-height: 16px;

    @media (min-width: 1720px) {
        ${setFontVariant("subtitle1", colorsPalettes.carbon[0])};
        line-height: 20px;
    }
`;
export const ButtonTextIcon = styled(NavBarIcon)`
    margin-right: 10px;
    justify-content: center;
    align-items: center;
`;
export const ButtonTextWrapper = styled(CenteredFlexRow)``;
export const ButtonTitle = styled.div`
    ${setFontVariant("h6", colorsPalettes.carbon[300])};
    margin-bottom: 25px;
    @media (max-width: 1919px) {
        ${setFontVariant("subtitle1", colorsPalettes.carbon[300])};
        margin-bottom: 12px;
    }

    @media (max-width: 1399px) {
        ${setFontVariant("input2", colorsPalettes.carbon[300])};
        margin-bottom: 12px;
    }
`;
export const ButtonText = styled(BaseFlex)`
    ${setFontVariant("button", colorsPalettes.blue[400])};
    line-height: 20px;
`;

export const IconPlay = styled(NavBarIcon)`
    position: absolute;
    border-radius: 50%;
    background-color: ${rgba(colorsPalettes.carbon[500], 0.7)};
    top: 50%;
    left: 50%;
    transform: translate(-50%, -50%);
`;

export const VideoButton = styled.div`
    border-radius: 6px;
    height: 100%;
    cursor: pointer;
    background: radial-gradient(
        100% 177.78% at 100% 0%,
        rgba(108, 185, 255, 0.6) 0.05%,
        rgba(97, 171, 253, 0.6) 6.02%,
        rgba(76, 143, 250, 0.6) 26.04%,
        rgba(59, 122, 248, 0.6) 41.67%,
        rgba(40, 98, 245, 0.6) 76.56%,
        rgba(38, 95, 245, 0.6) 99.9%
    );
    &:hover {
        background: radial-gradient(
            100% 177.78% at 100% 0%,
            #6cb9ff 0.05%,
            #61abfd 6.02%,
            #4c8ffa 26.04%,
            #3b7af8 41.67%,
            #2862f5 76.56%,
            #265ff5 99.9%
        );
        ${IconPlay} {
            background-color: ${colorsPalettes.blue[500]};
        }
    }
`;

export const GuideButton = styled(FlexColumn)`
    border-radius: 6px;
    padding-left: 20px;
    padding-right: 12px;
    align-items: start;
    justify-content: center;
    text-align: left;
    cursor: pointer;
    width: auto;
    height: 100%;

    background-color: ${rgba(colorsPalettes.carbon[0], 0.6)};
    &:hover {
        background-color: ${rgba(colorsPalettes.carbon[0], 1)};
        ${ButtonTitle} {
            color: ${colorsPalettes.carbon[500]};
        }
    }
`;

export const Text = styled.div`
    ${setFontVariant("subtitle1", colorsPalettes.carbon[400])};
    margin-right: 12px;
`;

export const EducationHat = styled.img`
    width: 28px;
    margin-right: 20px;
`;

export const CloseIcon = styled.div`
    margin-left: auto;
`;

export const Image = styled.img`
    object-fit: cover;
    height: 100%;
    width: 100%;
    border-bottom-right-radius: 6px;
`;

export const Info = styled(FlexRow)`
    padding-top: 12px;
    align-items: flex-start;
    width: 100%;
    margin-right: 110px;

    @media (max-width: 1919px) {
        margin-right: 240px;
        padding-top: 8px;
    }
    @media (max-width: 1600px) {
        margin-right: 52px;
    }
    @media (max-width: 1399px) {
        margin-right: 52px;
        padding-top: 12px;
    }
    @media (max-width: 1270px) {
        margin-right: 24px;
        padding-top: 12px;
    }
`;

export const Title = styled.div`
    ${setFontVariant("h5", colorsPalettes.carbon[500])};
    line-height: 16px;
    margin-bottom: 8px;

    @media (max-width: 1919px) {
        ${setFontVariant("subtitle1", colorsPalettes.carbon[500])};
    }
    @media (max-width: 1399px) {
        ${setFontVariant("subtitle2", colorsPalettes.carbon[500])};
    }
`;

export const Description = styled.div`
    ${setFontVariant("h5", colorsPalettes.carbon[300])};

    @media (max-width: 1919px) {
        ${setFontVariant("subtitle1", colorsPalettes.carbon[300])};
    }

    @media (max-width: 1399px) {
        ${setFontVariant("input2", colorsPalettes.carbon[300])};
    }
`;
